
<div class="card-container">
    @for( rsi of data; track $index) {        
        <mat-card class="status-card" [routerLink]="navigateForum(rsi)">
            <div class="card-heading">{{ rsi.forumId ? rsi.forumName : 'Channel Unassigned' }}</div>
            <div class="content">
                {{rsi.requests}}
            </div>
            <div class="footer">
                Open Request(s)
            </div>
        </mat-card>
    }
</div>